import React, { useCallback, useState } from "react";
import { Collapse } from "reactstrap";
import type { IRightPlacedChildren } from "interfaces/schemas/topology";
import { WizardSumarryItem } from "./WizardSummaryItem";

interface ICMRightPlacedChildrenProps {
  rightPlacedChildren: IRightPlacedChildren[];
  title: string;
  level: number;
  setSideBarId: (idToSet: string) => void;
}

export const CMRightPlacedChildren: React.FC<ICMRightPlacedChildrenProps> =
  React.memo(
    ({ rightPlacedChildren, title, setSideBarId, level = 0, ...rest }) => {
      const [isOpen, setIsOpen] = useState<boolean>(true);
      const hasChildren = rightPlacedChildren?.length;
      const handleToggle = useCallback(() => setIsOpen((val) => !val), []);

      return (
        <>
          <WizardSumarryItem
            isTopology
            title={title}
            handleToggle={handleToggle}
            isOpen={isOpen}
            level={level}
            hasChildren={hasChildren}
            setSideBarId={setSideBarId}
            {...rest}
          />
          <Collapse isOpen={isOpen} className="ps-3">
            {rightPlacedChildren?.map((item) => (
              <WizardSumarryItem
                {...item}
                setSideBarId={setSideBarId}
                key={item.id}
                isTopology
                title={item.title}
                handleToggle={handleToggle}
                isOpen={isOpen}
                level={level}
              />
            ))}
          </Collapse>
        </>
      );
    },
  );
